import React, { useEffect, useState } from "react";
import HelpCenterCard from "./HelpCenterCard";
import { FaSearch } from "react-icons/fa";

const HelpCenterCards = () => {
  const [tab, setTab] = useState("");
  const [isDark, setIsDark] = useState(() => {
    return JSON.parse(localStorage.getItem("isDark")) || false;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      setIsDark(JSON.parse(localStorage.getItem("isDark")) || false);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8691062301030113";
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div
        className={`helpCenterTab d-flex align-items-center justify-content-center flex-column ${
          isDark ? "dark-mode" : ""
        }`}
      >
        <h2 className="help-search-heading">Hello, May I Help You?</h2>
        <div className="help-search-container">
          <div className="help-search-box">
            <select className="category-dropdown">
              <option value="all">All Categories</option>
              <option value="slider">Slider</option>
              <option value="tutorial">Tutorial</option>
              <option value="html5">HTML5</option>
              <option value="css3">CSS3</option>
              <option value="prototyping">Prototyping</option>
            </select>
            <input
              type="search"
              className="helpcenter-search"
              placeholder="Type your question..."
            />
            <button className="search-button">
              <FaSearch />
            </button>
          </div>
        </div>
        <div className="helpcenter-categories">
          <span>Suggestion :</span>
          <ul>
            <li>Slider</li>
            <li>Tutorial</li>
            <li>HTML5</li>
            <li>CSS 3</li>
            <li>Prototyping</li>
          </ul>
        </div>
      </div>
      <div className="helpCenterCard">
        <HelpCenterCard tab={tab} />
      </div>
    </>
  );
};

export default HelpCenterCards;
